import { SvgProps } from "../../types";

const Navigate2 = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}>
    <path
      fill="#9FA3AE"
      d="M1.81 12.5c-.366 0-.68-.13-.94-.392a1.284 1.284 0 0 1-.392-.941V1.833c0-.366.13-.68.391-.941C1.13.63 1.444.5 1.811.5h4.667v1.333H1.81v9.334h9.333V6.5h1.333v4.667c0 .366-.13.68-.391.941a1.284 1.284 0 0 1-.942.392H1.811Zm3.134-3.533-.933-.934 6.2-6.2h-2.4V.5h4.666v4.667h-1.333v-2.4l-6.2 6.2Z"
    />
  </svg>
);
export default Navigate2;
